import { useEffect, useMemo, useState } from 'react';
import type { HistoryEntry } from '../types';
import { clearHistory, deleteHistory, listHistory } from '../lib/db';

interface Props {
  onOpen: (url: string) => void;
}

export function HistoryPage({ onOpen }: Props) {
  const [items, setItems] = useState<HistoryEntry[]>([]);
  const [query, setQuery] = useState('');
  const reload = () => listHistory().then(setItems);
  useEffect(() => { reload(); }, []);
  const filtered = useMemo(() => items.filter((item) => `${item.title} ${item.url}`.toLowerCase().includes(query.toLowerCase())), [items, query]);

  return (
    <section className="internal-page">
      <header className="page-header"><div><p className="eyebrow">websurf://history</p><h1>History</h1></div><button onClick={() => clearHistory().then(reload)}>Clear history</button></header>
      <input className="page-search" value={query} onChange={(event) => setQuery(event.target.value)} placeholder="Search history" />
      <div className="list-card">
        {filtered.map((item) => (
          <div className="list-row" key={item.id}>
            <img className="favicon" src={item.favicon || '/icons/mark-circle.png'} alt="" />
            <button className="row-main" onClick={() => onOpen(item.url)}><strong>{item.title}</strong><span>{item.url}</span></button>
            <time>{new Date(item.visitedAt).toLocaleString()}</time>
            <button onClick={() => deleteHistory(item.id).then(reload)}>Delete</button>
          </div>
        ))}
        {filtered.length === 0 && <p className="empty-copy">No matching history.</p>}
      </div>
    </section>
  );
}
